function empresa(){
  let item_buit = {
    id: 0,
    id_categoria: null,
    nom: '',
    descripcio_ca: null,
    descripcio_en: null,
    descripcio_es: null,
    oferta_ca: null,
    oferta_en: null,
    oferta_es: null,
    telefon: '',
    email: '',
    web: '',
    persona_contacte: '',
    adress: '',
    cp: '',
    ciutat: '',
    logo: null,
    fini: null,
    ffin: null,
    visible: false

  }
  return item_buit;
}

export {
  empresa,
};
